import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-light-svg-icons';
import { classnames } from '@/utils/html';
import theme from './ProductImagePlaceholder.module.scss';

export interface ProductImagePlaceholderProps {
    className?: string;
}

/**
 * Neutral placeholder shown wherever a product/option has no image — the option group list, the
 * option item list, and the product-image preview. Fills its parent, so the call site controls the
 * dimensions. Follows the codebase's existing "missing image" convention: a muted `faImage` glyph on
 * a light surface (as used by RoomStyleCard's Thumbnail fallback and List.Thumbnail's icon).
 */
export const ProductImagePlaceholder: React.FC<ProductImagePlaceholderProps> = ({ className }) => (
    <div className={classnames(theme.placeholder, className)} role="img" aria-hidden="true">
        <FontAwesomeIcon icon={faImage} className={theme.icon} />
    </div>
);
